module.exports = __webpack_public_path__ + "img/logo-sphera-500.4e0375e1.jpg";